import React from 'react';
import './Gallery.css';

import { Heading, PageTitle } from '../../../components';
import { gallery } from '../../../constants';

import { FaPlus } from 'react-icons/fa';

import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';



const Gallery = () => {

  return (
    <>
      {/* Page Title */}
      <PageTitle title={'Gallery'} page={'Gallery'} />

      <section className='gallery'>

        {/* Section heading */}
        <Heading title={'Our Gallery'} subTitle={'Explore Our Gallery'} />

        {/* Image Grid Container */}
        <div className='box-container'>
          {/* PhotoProvider to handle image preview */}
          <PhotoProvider>
            {gallery.map((image, index) => (

                <div className={`gallery-item gallery-${index + 1}`} key={index}>

                  {/* Display Image */}
                  <img src={image} alt={`gallery-${index + 1}`} /> 

                  {/* Image Hover Effect with Icon */}
                  <div className='content'>
                    <PhotoView key={index} src={image}>
                      <div className='icon'><FaPlus /></div>
                    </PhotoView>
                  </div>

                </div>
    
            ))}
          </PhotoProvider>
        </div>
      </section>
    </>
  );
};

export default Gallery;